module.exports = __webpack_public_path__ + "img/einstein.d8718b10.jpg";